import { Ico84Mail } from "@/shared/assets/icons/ico_84_mail";
import { useBreakpoint } from "../hooks/use-breakpoint";
import { useTranslations } from "next-intl";

export function EmailVerificationWaiting({ email }: { email: string }) {
  const { isMobile } = useBreakpoint();
  const t = useTranslations();

  return (
    <div className="tb:gap-12 flex flex-col items-center gap-6 text-center">
      <div className="bg-primary-100 tb:h-21 tb:w-21 flex h-14 w-14 items-center justify-center rounded-full">
        <Ico84Mail />
      </div>
      <div>
        <h3 className="heading-3-bold tb:mb-3 mb-2 text-gray-900">{t("f_em_title")}</h3>
        <p className="body-md-regular tb:mt-3 mt-[6px] text-gray-900">
          {isMobile ? (
            <>
              {t("f_em_context_1")}(<strong className="body-md-bold text-primary-700">{email}</strong>)
              {t("f_em_context_3")}
            </>
          ) : (
            <>
              {t("f_em_context_1")}(<strong className="body-md-bold text-primary-700">{email}</strong>)
              <br />
              {t("f_em_context_3")}
            </>
          )}
        </p>
      </div>
    </div>
  );
}
